"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
class Publisher {
    constructor() {
        this.subscribers = [];
        this.inBatch = false;
        this.pendingState = null;
    }
    subscribe(subscriber) {
        if (!this.subscribers.includes(subscriber)) {
            this.subscribers = [...this.subscribers, subscriber];
        }
        return () => {
            const subscriberIndex = this.subscribers.indexOf(subscriber);
            if (subscriberIndex >= 0) {
                this.subscribers = R.remove(subscriberIndex, 1, this.subscribers);
            }
        };
    }
    notify(state) {
        if (this.inBatch) {
            this.pendingState = state;
            return;
        }
        this.subscribers.forEach(subscriber => {
            subscriber(state);
        });
    }
    batch(fn) {
        this.inBatch = true;
        fn();
        this.inBatch = false;
        if (this.pendingState !== null) {
            this.notify(this.pendingState);
            this.pendingState = null;
        }
    }
}
exports.Publisher = Publisher;
//# sourceMappingURL=Publisher.js.map